const Check = (props) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill='currentColor'
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path 
        d="M6.61 11.89L3.5 8.78 2.44 9.84 6.61 14l8.95-8.95L14.5 4z"/
      >
    </svg>
  )
}

export default Check